export default __webpack_public_path__ + "static/classroom-2b44abe3a36113ac8804dd1af4ee37be.jpg";